import * as actionTypes from "./actionTypes";

export const fetchUSBDetection = (payload) => {
  return {
    type: actionTypes.FETCH_USB_DETECTION,
    payload,
  };
};

export const fetchUSBDetectionSuccess = (payload) => {
  return {
    type: actionTypes.FETCH_USB_DETECTION_SUCCESS,
    payload,
  };
};

export const fetchUSBDetectionFailed = (payload) => {
  return {
    type: actionTypes.FETCH_USB_DETECTION_FAILED,
    payload,
  };
};

export const fetchUSBDetectionReport = (payload) => {
  return {
    type: actionTypes.FETCH_USB_DETECTION_REPORT,
    payload,
  };
};

export const fetchUSBDetectionReportSuccess = (payload) => {
  return {
    type: actionTypes.FETCH_USB_DETECTION_REPORT_SUCCESS,
    payload,
  };
};

export const fetchUSBDetectionReportFailed = (payload) => {
  return {
    type: actionTypes.FETCH_USB_DETECTION_REPORT_FAILED,
    payload,
  };
};

export const downloadUSBDetection = (payload) => {
  return {
    type: actionTypes.DOWNLOAD_USB_DETECTION,
    payload,
  };
};

export const downloadUSBDetectionSuccess = (payload) => {
  return {
    type: actionTypes.DOWNLOAD_USB_DETECTION_SUCCESS,
    payload,
  };
};

export const downloadUSBDetectionFailed = (payload) => {
  return {
    type: actionTypes.DOWNLOAD_USB_DETECTION_FAILED,
    payload,
  };
};

export const downloadUSBDetectionReport = (payload) => {
  return {
    type: actionTypes.DOWNLOAD_USB_DETECTION_REPORT,
    payload,
  };
};

export const downloadUSBDetectionReportSuccess = (payload) => {
  return {
    type: actionTypes.DOWNLOAD_USB_DETECTION_REPORT_SUCCESS,
    payload,
  };
};

export const downloadUSBDetectionReportFailed = (payload) => {
  return {
    type: actionTypes.DOWNLOAD_USB_DETECTION_REPORT_FAILED,
    payload,
  };
};
